// removed by extract-text-webpack-plugin
module.exports = {"Buttons":"roomDetails__Buttons__JpWuk","Button":"roomDetails__Button__1M6o4","StateImage":"roomDetails__StateImage__2BeaZ","Edit":"roomDetails__Edit__GpzOg","Instructions":"roomDetails__Instructions__1JE8O","TextArea":"roomDetails__TextArea__3bGDr","EditButtons":"roomDetails__EditButtons__1t0Md"};


//////////////////
// WEBPACK FOOTER
// ./src/Layout/Dashboard/MainContent/roomDetails.css
// module id = 1271
// module chunks = 2